import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, FormControl, Validators, AbstractControl, ValidationErrors, FormGroup, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AstroServiceService } from 'src/app/admin/services/astroservice/astro-service.service';
import { InternationalServiceService } from 'src/app/admin/services/international-service/international-service.service';
import { LanguageDataService } from 'src/app/admin/services/language/language-data.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';
import { SkillsServiceService } from 'src/app/admin/services/skills/skills-service.service';

@Component({
  selector: 'app-edit-astrologer',
  templateUrl: './edit-astrologer.component.html',
  styleUrls: ['./edit-astrologer.component.scss'],
  standalone: false
})
export class EditAstrologerComponent implements OnInit {

  id: any = ''
  data: any = ''

  languageData: any = [];
  public skills: Array<any> = [];
  public languages: Array<any> = [];
  i: any;
  getWorkingStatus: Boolean | any;
  selectedLanguage: any = [];
  selectedLanguageJson: any = [];
  selectedSkills: any = [];
  selectedSkillsJson: any = [];
  defaultSkill: any = []
  defaultLanguage: any = []

  addAstrologerForm: any = new FormGroup({
    _id: new FormControl('', [Validators.required]),
    displayname: new FormControl('', [Validators.required, Validators.pattern('[A-Za-z]{1,}')]),
    name: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required, Validators.pattern('[6-9]{1}[0-9]{9}')]),
    gender: new FormControl('', [Validators.required]),
    consultant_type: new FormControl('', [Validators.required]),
    lang: new FormControl(''),
    working_with_other: new FormControl('', [Validators.required]),
    dob: new FormControl('', [Validators.required]),
    experience: new FormControl('', [Validators.required, Validators.pattern('[0-9]{1,2}')]),
    short_bio: new FormControl('', [Validators.required]),
    alternate_num: new FormControl('', [Validators.pattern('[6-9]{1}[0-9]{9}')]),
    profile_image: new FormControl(''),
    skill: new FormControl(''),
    complete_address: new FormControl(''),
    city: new FormControl(''),
    state: new FormControl(''),
    country: new FormControl(''),
    country_code: new FormControl(''),
    pincode: new FormControl(''),
    bank_account_num: new FormControl('', [Validators.pattern('[0-9]{1,}')]),
    promocall_totake: new FormControl('', [Validators.required, Validators.pattern('[0-9]{1,}')]),
    account_type: new FormControl(''),
    ifsc: new FormControl(''),
    account_holder_name: new FormControl(''),
    pan_number: new FormControl(''),
    addhar_number: new FormControl('', [Validators.pattern('[0-9]{12}')]),
    long_bio: new FormControl(''),
    proof_image: new FormControl(''),
  }, { validators: identityRevealedValidator })

  constructor(
    private router: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private skillsService: SkillsServiceService,
    private userdata: UserdataService,
    private language: LanguageDataService,
    private astroService: AstroServiceService,
    private internationalService: InternationalServiceService,
    private toast: ToastrService,
    private route: Router
  ) { }

  ngOnInit(): void {
    this.id = this.router.snapshot.paramMap.get('id')
    this.addAstrologerForm.patchValue({ _id: this.id })
    this.getSkillsList();
    this.getLaguangeList();
    this.getAstrologerDataById()

  }


  countryCodes = [
    { name: 'India', code: 'IN', phone_code: '91', emoji: '🇮🇳' },
    { name: 'UK', code: 'GB', phone_code: '44', emoji: '🇬🇧' },
    { name: 'USA', code: 'US', phone_code: '1', emoji: '🇺🇸' },
    { name: 'Algeria', code: 'DZ', phone_code: '213', emoji: '🇩🇿' },
    { name: 'Andorra', code: 'AD', phone_code: '376', emoji: '🇦🇩' },
    { name: 'Angola', code: 'AO', phone_code: '244', emoji: '🇦🇴' },
    { name: 'Anguilla', code: 'AI', phone_code: '1264', emoji: '🇦🇮' },
    { name: 'Antigua & Barbuda', code: 'AG', phone_code: '1268', emoji: '🇦🇬' },
    { name: 'Argentina', code: 'AR', phone_code: '54', emoji: '🇦🇷' },
    { name: 'Armenia', code: 'AM', phone_code: '374', emoji: '🇦🇲' },
    { name: 'Aruba', code: 'AW', phone_code: '297', emoji: '🇦🇼' },
    { name: 'Australia', code: 'AU', phone_code: '61', emoji: '🇦🇺' },
    { name: 'Austria', code: 'AT', phone_code: '43', emoji: '🇦🇹' },
    { name: 'Azerbaijan', code: 'AZ', phone_code: '994', emoji: '🇦🇿' },
    { name: 'Bahamas', code: 'BS', phone_code: '1242', emoji: '🇧🇸' },
    { name: 'Bahrain', code: 'BH', phone_code: '973', emoji: '🇧🇭' },
    { name: 'Bangladesh', code: 'BD', phone_code: '880', emoji: '🇧🇩' },
    { name: 'Barbados', code: 'BB', phone_code: '1246', emoji: '🇧🇧' },
    { name: 'Belarus', code: 'BY', phone_code: '375', emoji: '🇧🇾' },
    { name: 'Belgium', code: 'BE', phone_code: '32', emoji: '🇧🇪' },
    { name: 'Belize', code: 'BZ', phone_code: '501', emoji: '🇧🇿' },
    { name: 'Benin', code: 'BJ', phone_code: '229', emoji: '🇧🇯' },
    { name: 'Bermuda', code: 'BM', phone_code: '1441', emoji: '🇧🇲' },
    { name: 'Bhutan', code: 'BT', phone_code: '975', emoji: '🇧🇹' },
    { name: 'Bolivia', code: 'BO', phone_code: '591', emoji: '🇧🇴' },
    { name: 'Bosnia Herzegovina', code: 'BA', phone_code: '387', emoji: '🇧🇦' },
    { name: 'Botswana', code: 'BW', phone_code: '267', emoji: '🇧🇼' },
    { name: 'Brazil', code: 'BR', phone_code: '55', emoji: '🇧🇷' },
    { name: 'Brunei', code: 'BN', phone_code: '673', emoji: '🇧🇳' },
    { name: 'Bulgaria', code: 'BG', phone_code: '359', emoji: '🇧🇬' },
    { name: 'Burkina Faso', code: 'BF', phone_code: '226', emoji: '🇧🇫' },
    { name: 'Burundi', code: 'BI', phone_code: '257', emoji: '🇧🇮' },
    { name: 'Cambodia', code: 'KH', phone_code: '855', emoji: '🇰🇭' },
    { name: 'Cameroon', code: 'CM', phone_code: '237', emoji: '🇨🇲' },
    { name: 'Canada', code: 'CA', phone_code: '1', emoji: '🇨🇦' },
    { name: 'Cape Verde Islands', code: 'CV', phone_code: '238', emoji: '🇨🇻' },
    { name: 'Cayman Islands', code: 'KY', phone_code: '1345', emoji: '🇰🇾' },
    { name: 'Central African Republic', code: 'CF', phone_code: '236', emoji: '🇨🇫' },
    { name: 'Chile', code: 'CL', phone_code: '56', emoji: '🇨🇱' },
    { name: 'China', code: 'CN', phone_code: '86', emoji: '🇨🇳' },
    { name: 'Colombia', code: 'CO', phone_code: '57', emoji: '🇨🇴' },
    { name: 'Comoros', code: 'KM', phone_code: '269', emoji: '🇰🇲' },
    { name: 'Congo', code: 'CG', phone_code: '242', emoji: '🇨🇬' },
    { name: 'Cook Islands', code: 'CK', phone_code: '682', emoji: '🇨🇰' },
    { name: 'Costa Rica', code: 'CR', phone_code: '506', emoji: '🇨🇷' },
    { name: 'Croatia', code: 'HR', phone_code: '385', emoji: '🇭🇷' },
    { name: 'Cuba', code: 'CU', phone_code: '53', emoji: '🇨🇺' },
    { name: 'Cyprus North', code: 'CY', phone_code: '90392', emoji: '🇨🇾' },
    { name: 'Cyprus South', code: 'CY', phone_code: '357', emoji: '🇨🇾' },
    { name: 'Czech Republic', code: 'CZ', phone_code: '42', emoji: '🇨🇿' },
    { name: 'Denmark', code: 'DK', phone_code: '45', emoji: '🇩🇰' },
    { name: 'Djibouti', code: 'DJ', phone_code: '253', emoji: '🇩🇯' },
    { name: 'Dominica', code: 'DM', phone_code: '1809', emoji: '🇩🇲' },
    { name: 'Dominican Republic', code: 'DO', phone_code: '1809', emoji: '🇩🇴' },
    { name: 'Ecuador', code: 'EC', phone_code: '593', emoji: '🇪🇨' },
    { name: 'Egypt', code: 'EG', phone_code: '20', emoji: '🇪🇬' },
    { name: 'El Salvador', code: 'SV', phone_code: '503', emoji: '🇸🇻' },
    { name: 'Equatorial Guinea', code: 'GQ', phone_code: '240', emoji: '🇬🇶' },
    { name: 'Eritrea', code: 'ER', phone_code: '291', emoji: '🇪🇷' },
    { name: 'Estonia', code: 'EE', phone_code: '372', emoji: '🇪🇪' },
    { name: 'Ethiopia', code: 'ET', phone_code: '251', emoji: '🇪🇹' },
    { name: 'Falkland Islands', code: 'FK', phone_code: '500', emoji: '🇫🇰' },
    { name: 'Faroe Islands', code: 'FO', phone_code: '298', emoji: '🇫🇴' },
    { name: 'Fiji', code: 'FJ', phone_code: '679', emoji: '🇫🇯' },
    { name: 'Finland', code: 'FI', phone_code: '358', emoji: '🇫🇮' },
    { name: 'France', code: 'FR', phone_code: '33', emoji: '🇫🇷' },
    { name: 'French Guiana', code: 'GF', phone_code: '594', emoji: '🇬🇫' },
    { name: 'French Polynesia', code: 'PF', phone_code: '689', emoji: '🇵🇫' },
    { name: 'Gabon', code: 'GA', phone_code: '241', emoji: '🇬🇦' },
    { name: 'Gambia', code: 'GM', phone_code: '220', emoji: '🇬🇲' },
    { name: 'Georgia', code: 'GE', phone_code: '7880', emoji: '🇬🇪' },
    { name: 'Germany', code: 'DE', phone_code: '49', emoji: '🇩🇪' },
    { name: 'Ghana', code: 'GH', phone_code: '233', emoji: '🇬🇭' },
    { name: 'Gibraltar', code: 'GI', phone_code: '350', emoji: '🇬🇮' },
    { name: 'Greece', code: 'GR', phone_code: '30', emoji: '🇬🇷' },
    { name: 'Greenland', code: 'GL', phone_code: '299', emoji: '🇬🇱' },
    { name: 'Grenada', code: 'GD', phone_code: '1473', emoji: '🇬🇩' },
    { name: 'Guadeloupe', code: 'GP', phone_code: '590', emoji: '🇬🇵' },
    { name: 'Guam', code: 'GU', phone_code: '671', emoji: '🇬🇺' },
    { name: 'Guatemala', code: 'GT', phone_code: '502', emoji: '🇬🇹' },
    { name: 'Guinea', code: 'GN', phone_code: '224', emoji: '🇬🇳' },
    { name: 'Guinea - Bissau', code: 'GW', phone_code: '245', emoji: '🇬🇼' },
    { name: 'Guyana', code: 'GY', phone_code: '592', emoji: '🇬🇾' },
    { name: 'Haiti', code: 'HT', phone_code: '509', emoji: '🇭🇹' },
    { name: 'Honduras', code: 'HN', phone_code: '504', emoji: '🇭🇳' },
    { name: 'Hong Kong', code: 'HK', phone_code: '852', emoji: '🇭🇰' },
    { name: 'Hungary', code: 'HU', phone_code: '36', emoji: '🇭🇺' },
    { name: 'Iceland', code: 'IS', phone_code: '354', emoji: '🇮🇸' },
    { name: 'Indonesia', code: 'ID', phone_code: '62', emoji: '🇮🇩' },
    { name: 'Iran', code: 'IR', phone_code: '98', emoji: '🇮🇷' },
    { name: 'Iraq', code: 'IQ', phone_code: '964', emoji: '🇮🇶' },
    { name: 'Ireland', code: 'IE', phone_code: '353', emoji: '🇮🇪' },
    { name: 'Israel', code: 'IL', phone_code: '972', emoji: '🇮🇱' },
    { name: 'Italy', code: 'IT', phone_code: '39', emoji: '🇮🇹' },
    { name: 'Jamaica', code: 'JM', phone_code: '1876', emoji: '🇯🇲' },
    { name: 'Japan', code: 'JP', phone_code: '81', emoji: '🇯🇵' },
    { name: 'Jordan', code: 'JO', phone_code: '962', emoji: '🇯🇴' },
    { name: 'Kazakhstan', code: 'KZ', phone_code: '7', emoji: '🇰🇿' },
    { name: 'Kenya', code: 'KE', phone_code: '254', emoji: '🇰🇪' },
    { name: 'Kiribati', code: 'KI', phone_code: '686', emoji: '🇰🇮' },
    { name: 'Korea North', code: 'KP', phone_code: '850', emoji: '🇰🇵' },
    { name: 'Korea South', code: 'KR', phone_code: '82', emoji: '🇰🇷' },
    { name: 'Kuwait', code: 'KW', phone_code: '965', emoji: '🇰🇼' },
    { name: 'Kyrgyzstan', code: 'KG', phone_code: '996', emoji: '🇰🇬' },
    { name: 'Laos', code: 'LA', phone_code: '856', emoji: '🇱🇦' },
    { name: 'Latvia', code: 'LV', phone_code: '371', emoji: '🇱🇻' },
    { name: 'Lebanon', code: 'LB', phone_code: '961', emoji: '🇱🇧' },
    { name: 'Lesotho', code: 'LS', phone_code: '266', emoji: '🇱🇸' },
    { name: 'Liberia', code: 'LR', phone_code: '231', emoji: '🇱🇷' },
    { name: 'Libya', code: 'LY', phone_code: '218', emoji: '🇱🇾' },
    { name: 'Liechtenstein', code: 'LI', phone_code: '417', emoji: '🇱🇮' },
    { name: 'Lithuania', code: 'LT', phone_code: '370', emoji: '🇱🇹' },
    { name: 'Luxembourg', code: 'LU', phone_code: '352', emoji: '🇱🇺' },
    { name: 'Macao', code: 'MO', phone_code: '853', emoji: '🇲🇴' },
    { name: 'Macedonia', code: 'MK', phone_code: '389', emoji: '🇲🇰' },
    { name: 'Madagascar', code: 'MG', phone_code: '261', emoji: '🇲🇬' },
    { name: 'Malawi', code: 'MW', phone_code: '265', emoji: '🇲🇼' },
    { name: 'Malaysia', code: 'MY', phone_code: '60', emoji: '🇲🇾' },
    { name: 'Maldives', code: 'MV', phone_code: '960', emoji: '🇲🇻' },
    { name: 'Mali', code: 'ML', phone_code: '223', emoji: '🇲🇱' },
    { name: 'Malta', code: 'MT', phone_code: '356', emoji: '🇲🇹' },
    { name: 'Marshall Islands', code: 'MH', phone_code: '692', emoji: '🇲🇭' },
    { name: 'Martinique', code: 'MQ', phone_code: '596', emoji: '🇲🇶' },
    { name: 'Mauritania', code: 'MR', phone_code: '222', emoji: '🇲🇷' },
    { name: 'Mayotte', code: 'YT', phone_code: '269', emoji: '🇾🇹' },
    { name: 'Mexico', code: 'MX', phone_code: '52', emoji: '🇲🇽' },
    { name: 'Micronesia', code: 'FM', phone_code: '691', emoji: '🇫🇲' },
    { name: 'Moldova', code: 'MD', phone_code: '373', emoji: '🇲🇩' },
    { name: 'Monaco', code: 'MC', phone_code: '377', emoji: '🇲🇨' },
    { name: 'Mongolia', code: 'MN', phone_code: '976', emoji: '🇲🇳' },
    { name: 'Montserrat', code: 'MS', phone_code: '1664', emoji: '🇲🇸' },
    { name: 'Morocco', code: 'MA', phone_code: '212', emoji: '🇲🇦' },
    { name: 'Mozambique', code: 'MZ', phone_code: '258', emoji: '🇲🇿' },
    { name: 'Myanmar', code: 'MM', phone_code: '95', emoji: '🇲🇲' },
    { name: 'Namibia', code: 'NA', phone_code: '264', emoji: '🇳🇦' },
    { name: 'Nauru', code: 'NR', phone_code: '674', emoji: '🇳🇷' },
    { name: 'Nepal', code: 'NP', phone_code: '977', emoji: '🇳🇵' },
    { name: 'Netherlands', code: 'NL', phone_code: '31', emoji: '🇳🇱' },
    { name: 'New Caledonia', code: 'NC', phone_code: '687', emoji: '🇳🇨' },
    { name: 'New Zealand', code: 'NZ', phone_code: '64', emoji: '🇳🇿' },
    { name: 'Nicaragua', code: 'NI', phone_code: '505', emoji: '🇳🇮' },
    { name: 'Niger', code: 'NE', phone_code: '227', emoji: '🇳🇪' },
    { name: 'Nigeria', code: 'NG', phone_code: '234', emoji: '🇳🇬' },
    { name: 'Niue', code: 'NU', phone_code: '683', emoji: '🇳🇺' },
    { name: 'Norfolk Islands', code: 'NF', phone_code: '672', emoji: '🇳🇫' },
    { name: 'Northern Marianas', code: 'MP', phone_code: '670', emoji: '🇲🇵' },
    { name: 'Norway', code: 'NO', phone_code: '47', emoji: '🇳🇴' },
    { name: 'Oman', code: 'OM', phone_code: '968', emoji: '🇴🇲' },
    { name: 'Palau', code: 'PW', phone_code: '680', emoji: '🇵🇼' },
    { name: 'Panama', code: 'PA', phone_code: '507', emoji: '🇵🇦' },
    { name: 'Papua New Guinea', code: 'PG', phone_code: '675', emoji: '🇵🇬' },
    { name: 'Paraguay', code: 'PY', phone_code: '595', emoji: '🇵🇾' },
    { name: 'Peru', code: 'PE', phone_code: '51', emoji: '🇵🇪' },
    { name: 'Philippines', code: 'PH', phone_code: '63', emoji: '🇵🇭' },
    { name: 'Poland', code: 'PL', phone_code: '48', emoji: '🇵🇱' },
    { name: 'Portugal', code: 'PT', phone_code: '351', emoji: '🇵🇹' },
    { name: 'Puerto Rico', code: 'PR', phone_code: '1787', emoji: '🇵🇷' },
    { name: 'Qatar', code: 'QA', phone_code: '974', emoji: '🇶🇦' },
    { name: 'Reunion', code: 'RE', phone_code: '262', emoji: '🇷🇪' },
    { name: 'Romania', code: 'RO', phone_code: '40', emoji: '🇷🇴' },
    { name: 'Russia', code: 'RU', phone_code: '7', emoji: '🇷🇺' },
    { name: 'Rwanda', code: 'RW', phone_code: '250', emoji: '🇷🇼' },
    { name: 'San Marino', code: 'SM', phone_code: '378', emoji: '🇸🇲' },
    { name: 'Sao Tome & Principe', code: 'ST', phone_code: '239', emoji: '🇸🇹' },
    { name: 'Saudi Arabia', code: 'SA', phone_code: '966', emoji: '🇸🇦' },
    { name: 'Senegal', code: 'SN', phone_code: '221', emoji: '🇸🇳' },
    { name: 'Serbia', code: 'RS', phone_code: '381', emoji: '🇷🇸' },
    { name: 'Seychelles', code: 'SC', phone_code: '248', emoji: '🇸🇨' },
    { name: 'Sierra Leone', code: 'SL', phone_code: '232', emoji: '🇸🇱' },
    { name: 'Singapore', code: 'SG', phone_code: '65', emoji: '🇸🇬' },
    { name: 'Slovak Republic', code: 'SK', phone_code: '421', emoji: '🇸🇰' },
    { name: 'Slovenia', code: 'SI', phone_code: '386', emoji: '🇸🇮' },
    { name: 'Solomon Islands', code: 'SB', phone_code: '677', emoji: '🇸🇧' },
    { name: 'Somalia', code: 'SO', phone_code: '252', emoji: '🇸🇴' },
    { name: 'South Africa', code: 'ZA', phone_code: '27', emoji: '🇿🇦' },
    { name: 'Spain', code: 'ES', phone_code: '34', emoji: '🇪🇸' },
    { name: 'Sri Lanka', code: 'LK', phone_code: '94', emoji: '🇱🇰' },
    { name: 'St. Helena', code: 'SH', phone_code: '290', emoji: '🇸🇭' },
    { name: 'St. Kitts', code: 'KN', phone_code: '1869', emoji: '🇰🇳' },
    { name: 'St. Lucia', code: 'LC', phone_code: '1758', emoji: '🇱🇨' },
    { name: 'Sudan', code: 'SD', phone_code: '249', emoji: '🇸🇩' },
    { name: 'Suriname', code: 'SR', phone_code: '597', emoji: '🇸🇷' },
    { name: 'Swaziland', code: 'SZ', phone_code: '268', emoji: '🇸🇿' },
    { name: 'Sweden', code: 'SE', phone_code: '46', emoji: '🇸🇪' },
    { name: 'Switzerland', code: 'CH', phone_code: '41', emoji: '🇨🇭' },
    { name: 'Syria', code: 'SY', phone_code: '963', emoji: '🇸🇾' },
    { name: 'Taiwan', code: 'TW', phone_code: '886', emoji: '🇹🇼' },
    { name: 'Tajikstan', code: 'TJ', phone_code: '7', emoji: '🇹🇯' },
    { name: 'Thailand', code: 'TH', phone_code: '66', emoji: '🇹🇭' },
    { name: 'Togo', code: 'TG', phone_code: '228', emoji: '🇹🇬' },
    { name: 'Tonga', code: 'TO', phone_code: '676', emoji: '🇹🇴' },
    { name: 'Trinidad & Tobago', code: 'TT', phone_code: '1868', emoji: '🇹🇹' },
    { name: 'Tunisia', code: 'TN', phone_code: '216', emoji: '🇹🇳' },
    { name: 'Turkey', code: 'TR', phone_code: '90', emoji: '🇹🇷' },
    { name: 'Turkmenistan', code: 'TM', phone_code: '993', emoji: '🇹🇲' },
    { name: 'Turks & Caicos Islands', code: 'TC', phone_code: '1649', emoji: '🇹🇨' },
    { name: 'Tuvalu', code: 'TV', phone_code: '688', emoji: '🇹🇻' },
    { name: 'Uganda', code: 'UG', phone_code: '256', emoji: '🇺🇬' },
    { name: 'Ukraine', code: 'UA', phone_code: '380', emoji: '🇺🇦' },
    { name: 'United Arab Emirates', code: 'AE', phone_code: '971', emoji: '🇦🇪' },
    { name: 'Uruguay', code: 'UY', phone_code: '598', emoji: '🇺🇾' },
    { name: 'Uzbekistan', code: 'UZ', phone_code: '7', emoji: '🇺🇿' },
    { name: 'Vanuatu', code: 'VU', phone_code: '678', emoji: '🇻🇺' },
    { name: 'Vatican City', code: 'VA', phone_code: '379', emoji: '🇻🇦' },
    { name: 'Venezuela', code: 'VE', phone_code: '58', emoji: '🇻🇪' },
    { name: 'Vietnam', code: 'VN', phone_code: '84', emoji: '🇻🇳' },
    { name: 'Virgin Islands - British', code: 'VG', phone_code: '1284', emoji: '🇻🇬' },
    { name: 'Virgin Islands - US', code: 'VI', phone_code: '1340', emoji: '🇻🇮' },
    { name: 'Wallis & Futuna', code: 'WF', phone_code: '681', emoji: '🇼🇫' },
    { name: 'Yemen (North)', code: 'YE', phone_code: '969', emoji: '🇾🇪' },
    { name: 'Yemen (South)', code: 'YE', phone_code: '967', emoji: '🇾🇪' },
    { name: 'Zambia', code: 'ZM', phone_code: '260', emoji: '🇿🇲' },
    { name: 'Zimbabwe', code: 'ZW', phone_code: '263', emoji: '🇿🇼' }
  ];

  countryData: any = [];
  countryCode = ''




  getAstrologerDataById() {
    this.astroService.getAstrologerDataById({ _id: this.id }).subscribe(
      (res: any) => {
        this.data = res.data
        this.addAstrologerForm.patchValue({ working_with_other: this.data.working_with_other ? 'yes' : 'no' })
        this.addAstrologerForm.patchValue({ displayname: this.data.displayname })
        this.addAstrologerForm.patchValue({ name: this.data.name })
        this.addAstrologerForm.patchValue({ phone: this.data.phone })
        this.addAstrologerForm.patchValue({ gender: this.data.gender })
        this.addAstrologerForm.patchValue({ alternate_num: this.data.alternate_num })
        this.addAstrologerForm.patchValue({ consultant_type: this.data.consultant_type })
        this.addAstrologerForm.patchValue({ experience: this.data.experience })
        this.addAstrologerForm.patchValue({ country_code: String(this.data.country_code) })
        this.addAstrologerForm.patchValue({ complete_address: this.data.complete_address })
        this.addAstrologerForm.patchValue({ city: this.data.city })
        this.addAstrologerForm.patchValue({ state: this.data.state })
        this.addAstrologerForm.patchValue({ country: this.data.country })
        this.addAstrologerForm.patchValue({ pincode: this.data.pincode })
        this.addAstrologerForm.patchValue({ bank_account_num: this.data.bank_account_num })
        this.addAstrologerForm.patchValue({ account_type: this.data.account_type })
        this.addAstrologerForm.patchValue({ ifsc: this.data.ifsc })
        this.addAstrologerForm.patchValue({ account_holder_name: this.data.account_holder_name })
        this.addAstrologerForm.patchValue({ pan_number: this.data.pan_number })
        this.addAstrologerForm.patchValue({ addhar_number: this.data.addhar_number })
        this.addAstrologerForm.patchValue({ short_bio: this.data.short_bio })
        this.addAstrologerForm.patchValue({ long_bio: this.data.long_bio })
        this.addAstrologerForm.patchValue({ promocall_totake: this.data.promocall_totake })
        const selectedLangIds: string[] = [];
        for (const lang of this.data.lang) {
  
          selectedLangIds.push(lang.langId._id); 
        }
        this.addAstrologerForm.patchValue({
          lang: selectedLangIds
        });
        const selectedSkillIds: string[] = [];
        for (const skill of this.data.skill) {
          selectedSkillIds.push(skill.skillId._id);
        }
        this.addAstrologerForm.patchValue({
          skill: selectedSkillIds
        });

        const day = Number(this.data.birth_date);
        const month = Number(this.data.birth_month) - 1;
        const year = Number(this.data.birth_year);
        const dateObj = new Date(year, month, day);
        this.addAstrologerForm.patchValue({ dob: dateObj });


      }
    )
  }

  proofError: string = '';
  selectedProofFileName: string = '';
  public onProofImageUpload(evnt: any) {
    const input = evnt.target as HTMLInputElement;
    if (input.files?.length) {
      this.selectedProofFileName = input.files[0].name;
      if (evnt.target.files.length > 0) {
        this.proofError = ''
        if (evnt.target.files.length > 0) {
          if (evnt.target.files && evnt.target.files[0]) {
            const allowed_types = ['image/png', 'image/jpeg'];
            if (!_.includes(allowed_types, evnt.target.files[0].type)) {
              this.proofError = 'Only Images are allowed ( JPG | PNG )';
              return;
            } else {
              this.addAstrologerForm.patchValue({
                proof_image: evnt.target.files[0]
              })
            }
          }
        }
      }
    }

  }

  profileError: string = '';
  selectedFileName: string = '';
  public onProfileImageUpload(evnt: any) {
    const input = evnt.target as HTMLInputElement;
    if (input.files?.length) {
      this.selectedFileName = input.files[0].name;
      this.profileError = ''
      if (evnt.target.files.length > 0) {
        if (evnt.target.files && evnt.target.files[0]) {
          const allowed_types = ['image/png', 'image/jpeg'];
          if (!_.includes(allowed_types, evnt.target.files[0].type)) {
            this.profileError = 'Only Images are allowed ( JPG | PNG )';
            return;
          } else {
            this.addAstrologerForm.patchValue({
              profile_image: evnt.target.files[0]
            })
          }
        }
      }
    }


  }

  getLaguangeList() {
    this.spinner.show()
    this.language.getLaguangeList(this.userdata.getData()).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.languageData = res.data;

      },
      (err) => {

      }
    );
  }

  skillsData: any = [];
  getSkillsList() {
    this.spinner.show()
    this.skillsService.getSkillsList(this.userdata.getData()).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.skillsData = res.data;
      },
      (err) => {
        this.spinner.hide()

      }
    );
  }



  get f() {
    return this.addAstrologerForm.controls
  }



  public onAddAstrologerSubmit() {

    this.spinner.show()
    var choosenLangues = this.addAstrologerForm.get("lang").value
    choosenLangues.forEach((element: { value: any; }) => {
      this.selectedLanguage.push(element.value)
    });
    this.selectedLanguage.forEach((element: any) => {
      this.selectedLanguageJson.push({ "langId": element })
    });

    var choosenSkills = this.addAstrologerForm.get("skill").value
    choosenSkills.forEach((element: { value: any; }) => {
      this.selectedSkills.push(element.value)
    });
    this.selectedSkills.forEach((element: any) => {
      this.selectedSkillsJson.push({ "skillId": element })
    });
    //-------/tags json-----//

    var convertBoolean = this.addAstrologerForm.get("working_with_other").value

    if (convertBoolean == "yes") {
      this.getWorkingStatus = true;
    } else {
      this.getWorkingStatus = false;
    }
    //console.log(JSON.stringify(this.selectedLanguageJson),JSON.stringify(this.selectedSkillsJson))
    //return;
    const data = new FormData()

    const dob = this.addAstrologerForm.value.dob;

    if (dob) {
      let day = dob.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      let month = dob.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      const year = dob.getFullYear();

      data.append('birth_date', day.toString());
      data.append('birth_month', month.toString());
      data.append('birth_year', year.toString());
    }

    data.append("displayname", this.addAstrologerForm.get("displayname").value)
    data.append("name", this.addAstrologerForm.get("name").value)
    data.append("phone", this.addAstrologerForm.get("phone").value)
    data.append("gender", this.addAstrologerForm.get("gender").value)
    data.append("alternate_num", this.addAstrologerForm.get("alternate_num").value)
    data.append("profile_image", this.addAstrologerForm.get("profile_image").value)

    data.append("consultant_type", this.addAstrologerForm.get("consultant_type").value)
    data.append("experience", this.addAstrologerForm.get("experience").value)


    const langArray = this.addAstrologerForm.value.lang.map((id: string) => ({ langId: id }));
    const skillArray = this.addAstrologerForm.value.skill.map((id: string) => ({ skillId: id }));

    data.append("lang", JSON.stringify(langArray));
    data.append("skill", JSON.stringify(skillArray));


    data.append("complete_address", this.addAstrologerForm.get("complete_address").value)
    data.append("city", this.addAstrologerForm.get("city").value)
    data.append("state", this.addAstrologerForm.get("state").value)
    data.append("country", this.addAstrologerForm.get("country").value)
    data.append("country_code", this.addAstrologerForm.get("country_code").value)
    data.append("pincode", this.addAstrologerForm.get("pincode").value)
    data.append("bank_account_num", this.addAstrologerForm.get("bank_account_num").value)
    data.append("account_type", this.addAstrologerForm.get("account_type").value)
    data.append("ifsc", this.addAstrologerForm.get("ifsc").value)
    data.append("account_holder_name", this.addAstrologerForm.get("account_holder_name").value)
    data.append("pan_number", this.addAstrologerForm.get("pan_number").value)
    data.append("addhar_number", this.addAstrologerForm.get("addhar_number").value)
    data.append("working_with_other", this.getWorkingStatus)
    data.append("short_bio", this.addAstrologerForm.get("short_bio").value)
    data.append("long_bio", this.addAstrologerForm.get("long_bio").value)
    data.append("proof_image", this.addAstrologerForm.get("proof_image").value)
    data.append("promocall_totake", this.addAstrologerForm.get("promocall_totake").value)
    data.append("_id", this.addAstrologerForm.get("_id").value)

    this.astroService.updateAstrologer(data).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.toast.success('Astrologer Updated!', 'Sucess')
        this.route.navigateByUrl('/admin/astro/list')
      },
      err => {
        this.spinner.hide()
        //this.toast.error('Something went wrong!', 'Error')
        this.toast.error(err.error.message, 'Error')
        //console.log(err)
      }
    )
  }
}
const identityRevealedValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const phone = control.get('phone');
  const alternate_num = control.get('alternate_num');

  return phone && alternate_num && phone.value === alternate_num.value ? { identityRevealed: true } : null;
};
